module.exports = __webpack_public_path__ + "static/media/tp.23a02706.jpg";